export const EDIT_GROUP = "EDIT_GROUP"
export const EDIT_GROUP_SUCCESS = "EDIT_GROUP_SUCCESS"
export const EDIT_GROUP_CLEAN = "EDIT_USER_CLEAN"
export const API_ERROR = "API_ERROR"
